import { Spinner } from './ui/spinner';

interface LoadingSpinnerProps {
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const spinnerSizes = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
} as const;

export function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
    return <Spinner size={spinnerSizes[size]} className={className} />;
}

export function LoadingPage({ message = 'Loading...' }: { message?: string }) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/60 backdrop-blur-sm">
            <div className="flex min-w-64 flex-col items-center gap-3 rounded-xl border bg-card p-6 shadow-md">
                <Spinner size="lg" className="text-primary" />
                <p className="text-sm font-medium text-muted-foreground">{message}</p>
            </div>
        </div>
    );
}

export function InlineSpinner({ className = '' }: { className?: string }) {
    return <Spinner size="xs" className={`inline-block ${className}`} />;
}
